// extracted by mini-css-extract-plugin
export default {"btnPrimary":"cb8a6go6t","btnHeader":"czzb4stnu","buttonLink":"clmda0jnz","white":"ch3e38ejf","action":"ca0k56fqi","buttonImage":"cb5m2u1yw","btnGray":"cshmzupy9"};